export default __webpack_public_path__ + "static/media/chop.5ba03ef4.gif";